const {Component} = require("react");
const PropTypes = require("prop-types");
const router = require("app/services/router");
const queryObject = require("app/util/queryObject");
const Check = require("app/components/checkout/steps/payment/Check");
const Image = require("app/components/mixins/LazyImg");

class Option extends Component {

    static get propTypes() {
        return {
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            selected: PropTypes.bool.isRequired,
            cart: PropTypes.object.isRequired,
            image: PropTypes.string,
            onSelect: PropTypes.func,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            selected: props.selected,
            cart: this.props.cart
        };
    }

    componentWillReceiveProps(nextProps) {
        let payload = {};

        if (nextProps.hasOwnProperty("selected") && (this.state.selected !== nextProps.selected)) {
            payload.selected = nextProps.selected;
        }

        if (nextProps.cart !== this.state.cart) {
            payload.cart = nextProps.cart;
        }

        if (Object.keys(payload).length > 0) {
            this.setState(payload);
        }
    }

    get cart() {
        return this.state.cart;
    }

    get className() {
        let classList = ["option", this.props.id];

        if (this.state.selected) {
            classList.push("selected");
        }

        return classList.join(" ");
    }

    value(query, defaultValue = null) {
        return queryObject(this.cart, query, defaultValue);
    }

    renderImage() {
        if (this.props.image) {
            return (
                <img src={router.url(this.props.image)} alt={this.props.title} />
            );
        }
    }

    _onClick = () => {
        if (typeof this.props.onSelect === "function") {
            this.props.onSelect(this.props.id);
        }
    };

    renderContents() {
        // ...
    }

    render() {
        return (
            <div className={this.className} onClick={this._onClick}>
                <Check checked={this.state.selected}/>
                <div className="details">
                    <div className="title">{this.props.title}</div>
                    <div className="description">{this.props.description}</div>
                    {this.renderImage()}
                    {this.renderContents()}
                </div>
            </div>
        );
    }
}

module.exports = Option;